import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";

interface Props {
  onImageSelect: (file: File) => void;
  onImageRemove: () => void;
}

const ImageUploadWithPreview: React.FC<Props> = ({ onImageSelect, onImageRemove }) => {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        toast.warning("Only JPG, JPEG, and PNG files are allowed.");
        e.target.value = "";
        return;
      }
      setSelectedImage(file);
      setPreviewUrl(URL.createObjectURL(file));
      onImageSelect(file);
    }
  };

  const handleRemove = () => {
    setSelectedImage(null);
    setPreviewUrl(null);
    onImageRemove(); 
  };

  return (
    <div className="d-flex gap-2 my-3 flex-column">
      {!selectedImage && (
        <form>
          <label>
            Image {'  '}
            <input type="file" accept=".jpg,.jpeg,.png" onChange={handleImageChange} />
          </label>
        </form>
      )}

      {previewUrl && (
        <div className="d-flex gap-2">
          <Button className="btn add-btn" onClick={() => setShowModal(true)}>
            View Image
          </Button>
          <Button className="btn submit-btn" onClick={handleRemove}>
            Remove
          </Button>
        </div>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Preview Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {previewUrl && <img src={previewUrl} alt="Preview" className="img-fluid" />}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ImageUploadWithPreview;
